const envConfig = require('../config/config.json')

export async function fetchConfigInformation() {
  const configUrl = `${envConfig.cloudFunctions.url}/getRemoteConfig`
  const response = await fetch(configUrl)
  const json = await response.json()
  return json
}
